import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { ProductsService } from '../services/products.service';
import { ObjectAddService } from '../Component(2D and 3D)/3D/ObjectAdd/object-add.service';
import { Select3dService } from '../services/select-3d.service';
import { StageService } from '../services/stage.service';
import { EventLogService, Actions } from '../services/eventLog';
import { DockModeService } from '../services/dock-mode.service';
import { environment } from "../../environments/environment";

@Component({
  selector: 'app-add-accessories',
  templateUrl: './add-accessories.component.html',
  styleUrls: ['./add-accessories.component.scss']
})
export class AddAccessoriesComponent implements OnInit {

  @Output() step1Editer = new EventEmitter();
  // menu key emitted by the Back button: the panel lives in the step-1 pane
  // and (for docks, spec pp.12-16) also in the step-2 pane
  @Input() backTarget = 'step1';

  apiUrl: string = environment.apiUrl;

  public accessories: Array<any> = [];

  constructor(
    private productsService: ProductsService,
    private objectAddService: ObjectAddService,
    private select3dService: Select3dService,
    private stageSrvc: StageService,
    private eventLog: EventLogService,
    public dockModeService: DockModeService
  ) {
  }


  goBack(value) {
    this.step1Editer.emit({ name: value });
  }


  itemClick(acc: any): void {
    this.objectAddService.setEntity(acc);
  }

  getImgUrl(acc: any): string {
    return acc.localAsset
      ? `../../assets/images/${acc.productImg}`
      : `${this.apiUrl}/containers/images/download/${acc.productImg}`;
  }

  remove() {
    const accessories = this.select3dService.getSelectedAccessories();
    accessories.forEach(accessory => this.eventLog.dispatch(new Actions.ObjectDeleteAction(accessory)));
  }

  ngOnInit() {
    this.loadAccessories();
    // the component is instantiated at app start ([hidden]-based panes) —
    // refilter when the deck/dock mode changes later
    this.dockModeService.modeChanged.subscribe(() => this.loadAccessories());
  }

  private loadAccessories() {
    this.productsService.getAccessories().then(accs => {
      // docks see the full catalog plus the dock-only props; decks see the
      // catalog as always (dock-only props are hidden from them)
      const isDock = this.dockModeService.isDockMode();
      this.accessories = isDock
        ? accs
        : accs.filter(acc => acc.application !== 'dock');
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/add-accessories/add-accessories.component.ts